function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["value", "options", "inputValue", "prefixClassName", "maxHeight", "onEnter", "size", "filterOptions", "required", "error", "label", "placeholder", "disabled", "noResultsText", "onChange", "onInputValueChange", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useRef, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
import classNames from "classnames";
import { noop, attempt, isError, isEmpty } from "lodash-es";
import { useRect } from "../../helpers/hooks";
import { useKeyboardMenuScroll } from "../../helpers/downshiftScroll";
import { Search, Close } from "../../icons";
import Input from "../../forms/input/Input";
import { onEnter as onEnterHelper } from "../../helpers";
import { Label } from "../label/Label";
export var MAX_OPTIONS_HEIGHT = 254;
var INPUT_HEIGHT = 38;
var BORDER_HEIGHT = 1;
export var MAX_RESULTS_BOX_HEIGHT = MAX_OPTIONS_HEIGHT + INPUT_HEIGHT + BORDER_HEIGHT * 2;
var SearchSuggestionSelect = function SearchSuggestionSelect(_ref) {
  var _useRect;
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? "" : _ref$value,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    inputValue = _ref.inputValue,
    _ref$prefixClassName = _ref.prefixClassName,
    prefixClassName = _ref$prefixClassName === void 0 ? "tui-select" : _ref$prefixClassName,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? 200 : _ref$maxHeight,
    _ref$onEnter = _ref.onEnter,
    onEnter = _ref$onEnter === void 0 ? noop : _ref$onEnter,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$filterOptions = _ref.filterOptions,
    filterOptions = _ref$filterOptions === void 0 ? true : _ref$filterOptions,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    error = _ref.error,
    label = _ref.label,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$noResultsText = _ref.noResultsText,
    noResultsText = _ref$noResultsText === void 0 ? "No results found." : _ref$noResultsText,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    onInputValueChange = _ref.onInputValueChange,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuIsOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var ref = useRef(null);
  var optionsRef = useRef();
  var rect = (_useRect = useRect(ref)) !== null && _useRect !== void 0 ? _useRect : {};
  var _useKeyboardMenuScrol = useKeyboardMenuScroll(),
    trackStateChange = _useKeyboardMenuScrol.trackStateChange,
    scrollIntoView = _useKeyboardMenuScrol.scrollIntoView;
  var selectedItem = value !== undefined && value !== null && value !== "" ? options.find(function (e) {
    return e.value === value;
  }) : {};
  function onInputValueChangeWrapper(val) {
    if (val !== inputValue) {
      onInputValueChange(val);
    }
  }
  useLayoutEffect(function () {
    var inputMargin = 4;
    var styles = {
      top: "".concat(rect.top + rect.height + inputMargin, "px"),
      left: "".concat(rect.left, "px"),
      right: "".concat(rect.right, "px"),
      width: "".concat(rect.width, "px"),
      minHeight: "".concat(rect.height, "px"),
      transform: null,
      position: "fixed",
      height: null
    };
    var collidesWithBottom = window.innerHeight <= rect.bottom + MAX_RESULTS_BOX_HEIGHT;
    if (collidesWithBottom) {
      // when options' rect extends past the bottom of the window move it above the input
      styles.transform = "translateY(-100%) translateY(-".concat(rect.height + inputMargin * 2, "px)");
      styles.height = "".concat(MAX_OPTIONS_HEIGHT, "px");
    }
    Object.entries(styles).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      optionsRef.current.style[key] = value;
    });
  }, [rect.top, rect.left, rect.right, rect.width, rect.height]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "".concat(prefixClassName, "-wrapper search-select ").concat(size),
    style: style
  }, /*#__PURE__*/React.createElement(Downshift, {
    itemToString: function itemToString(item) {
      return item ? item.label : "";
    },
    isOpen: menuIsOpen,
    selectedItem: selectedItem,
    onStateChange: function onStateChange(changes) {
      if (changes !== null && changes !== void 0 && changes.selectedItem) {
        onChange(changes.selectedItem);
      }
      if (!menuIsOpen && changes.inputValue) {
        setIsOpen(true);
      }
    },
    onSelect: function onSelect() {
      setIsOpen(false);
      document.activeElement.blur();
    },
    onInputValueChange: function onInputValueChange(value) {
      if (value !== undefined && !Object.is(inputValue, value)) {
        onInputValueChangeWrapper(value || "");
      }
    },
    scrollIntoView: scrollIntoView,
    stateReducer: function stateReducer(state, changes) {
      trackStateChange(changes);
      var highlightedIndex = changes.highlightedIndex;
      switch (changes.type) {
        case Downshift.stateChangeTypes.keyDownArrowDown:
        case Downshift.stateChangeTypes.keyDownArrowUp:
          {
            var inputValueAttempt = attempt(function () {
              var option = ref.current.querySelectorAll("li")[highlightedIndex];
              if (option) {
                option.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest"
                });
              }
              return option ? option.innerText : state.inputValue;
            });
            if (isError(inputValueAttempt)) return changes;
            return _objectSpread(_objectSpread({}, changes), {}, {
              inputValue: inputValueAttempt
            });
          }
        default:
          return changes;
      }
    }
  }, function (_ref4) {
    var getInputProps = _ref4.getInputProps,
      getItemProps = _ref4.getItemProps,
      getMenuProps = _ref4.getMenuProps,
      isOpen = _ref4.isOpen,
      clearSelection = _ref4.clearSelection,
      getLabelProps = _ref4.getLabelProps;
    function onClearInput(e) {
      e.stopPropagation();
      clearSelection();
      onChange({});
      onInputValueChangeWrapper("");
      setIsOpen(false);
    }
    function getOptions(options) {
      if (!filterOptions) return options;
      return options.filter(function (o) {
        return o.label.toLowerCase().includes(inputValue.toLowerCase());
      });
    }
    var itemIndex = 0;
    function renderOptions(options) {
      var optionsToRender = getOptions(options);
      if (optionsToRender.length === 0) return /*#__PURE__*/React.createElement("div", {
        className: "no-results"
      }, noResultsText);
      return optionsToRender.map(function (item) {
        return /*#__PURE__*/React.createElement("li", getItemProps({
          key: item.value,
          index: itemIndex++,
          item: item,
          className: classNames("".concat(prefixClassName, "-options-item"), {
            selected: item.value === selectedItem.value
          })
        }), item.label);
      });
    }
    return /*#__PURE__*/React.createElement("div", _extends({
      style: {
        position: "relative"
      }
    }, label ? {
      "aria-labelledby": undefined
    } : {}), label && /*#__PURE__*/React.createElement(Label, _extends({}, getLabelProps(), {
      required: required
    }), label), /*#__PURE__*/React.createElement(Input, {
      size: size,
      icon: {
        position: "left",
        render: function render() {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Search, null), (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > 0 && /*#__PURE__*/React.createElement(Close, {
            className: "close-icon",
            role: "button",
            tabIndex: "0",
            onKeyPress: onEnterHelper(onClearInput),
            onClick: onClearInput,
            style: {
              right: 0,
              left: "unset"
            }
          }));
        }
      },
      disabled: disabled,
      onClick: function onClick() {
        return setIsOpen(true);
      },
      onBlur: function onBlur() {
        return setIsOpen(false);
      },
      value: inputValue || "",
      className: classNames({
        "has-error": error
      }),
      inputProps: getInputProps({
        placeholder: placeholder,
        className: classNames("texada-ui-dropdown", {
          "is-open": isOpen
        }),
        disabled: disabled,
        onKeyPress: onEnterHelper(function () {
          setIsOpen(false);
          onEnter();
        })
      })
    }), /*#__PURE__*/React.createElement("div", {
      ref: optionsRef,
      className: classNames("".concat(prefixClassName, "-options"))
    }, isOpen && !disabled && /*#__PURE__*/React.createElement("ul", _extends({}, getMenuProps(), {
      style: {
        maxHeight: maxHeight
      }
    }), /*#__PURE__*/React.createElement(React.Fragment, null, Array.isArray(options) ? renderOptions(options) : Object.entries(options).map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        categoryLabel = _ref6[0],
        options = _ref6[1];
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: categoryLabel
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixClassName, "-category")
      }, categoryLabel), renderOptions(options));
    })))));
  }), error && !isEmpty(error) ? /*#__PURE__*/React.createElement("div", {
    className: "tui-invalid-feedback"
  }, error) : "");
};
SearchSuggestionSelect.propTypes = {
  options: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  maxHeight: PropTypes.number,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  prefixClassName: PropTypes.string,
  onChange: PropTypes.func,
  inputValue: PropTypes.string.isRequired,
  onInputValueChange: PropTypes.func.isRequired,
  noResultsText: PropTypes.string,
  disabled: PropTypes.bool,
  onEnter: PropTypes.func,
  size: PropTypes.string,
  filterOptions: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
export default SearchSuggestionSelect;
//# sourceMappingURL=SearchSuggestionSelect.js.map